let meta = {};
const INSTRUMENTS_SECTION = 'instruments';

function get (name, defaultValue) {
    return meta[name] || defaultValue;
}

export function setMeta (data) {
    if (!data.hasOwnProperty(INSTRUMENTS_SECTION)) {
        data[INSTRUMENTS_SECTION] = {};
    }
    meta = data;
}

/**
 * Returns instrument meta information.
 *
 * @param {string} name        An instrument code
 * @param {string|null} prop   A meta propety name.
 * @param {mixen} defaultValue A dafault value that returns if meta property not exist
 * @returns {mixen}
 */
export function getInstrumentMeta (name, prop = null, defaultValue = null) {
    let metaInstrument = meta[INSTRUMENTS_SECTION][name] || null;
    if (!metaInstrument || !prop) {
        return metaInstrument;
    }

    return metaInstrument[prop] || defaultValue;
}

export { meta as default };



// WEBPACK FOOTER //
// ./src/app/meta.js